module.exports = __webpack_public_path__ + "static/media/Bay6.838219ae.JPG";